var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBinIconFilledGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_17963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.85354 19.2C5.85354 20.3 6.73159 21.2 7.80476 21.2H15.6096C16.6828 21.2 17.5609 20.3 17.5609 19.2V7.19995H5.85354V19.2ZM18.5365 4.19995H15.1218L14.1462 3.19995H9.26817L8.29256 4.19995H4.87793V6.19995H18.5365V4.19995Z",
    fill: "#A1B5BC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_17963"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.4146,
    height: 24,
    fill: "white",
    transform: "translate(0 0.200195)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinIconFilledGrey);
export default __webpack_public_path__ + "static/media/bin-icon-filled-grey.9ce7ef84098a9a60c0031e3559fa616f.svg";
export { ForwardRef as ReactComponent };